import type { CurrencyOption } from "@/types/currency";

export interface CountryConfig {
  /** Matches the rc_country cookie value. */
  code: string;
  name: string;
  emoji: string;
  /** ISO alpha-2 lowercase, for the Flag component. */
  flagCode: string;
  /** URL prefix for this country's dedicated pages, e.g. "/ca". */
  path: string;
  /** Currency visitors from this country send from — defaults calculators sitewide. */
  currency: CurrencyOption;
  /** Extra prominent nav link shown only while browsing this country's pages. */
  corridorLink?: { label: string; href: string };
  /** Maps an international path to this country's equivalent, e.g. { "/": "/ca" }. */
  redirects?: Record<string, string>;
}

export const COUNTRIES: CountryConfig[] = [
  {
    code: "CA",
    name: "Canada",
    emoji: "🇨🇦",
    flagCode: "ca",
    path: "/ca",
    currency: {
      currency_code: "CAD",
      currency_name: "Canadian Dollar",
      country_name: "Canada",
      code_alpha2: "ca",
    },
    corridorLink: { label: "Send Money to Canada", href: "/money-transfer/send-money-to-canada" },
    redirects: {
      "/": "/ca",
      "/legal/regulatory": "/ca/legal/regulatory",
      "/legal/terms-and-conditions": "/ca/legal/terms-and-conditions",
      "/legal/privacy-policy": "/ca/legal/privacy-policy",
      "/legal/cookie-policy": "/ca/legal/cookie-policy",
      "/legal/complaints-policy": "/ca/legal/complaints-policy",
      "/legal/promotional-offer-terms-and-conditions": "/ca/legal/promotional-offer-terms-and-conditions",
      "/legal/personalised-ads": "/ca/legal/personalised-ads",
    },
  },
];

export function getCountryByCode(code: string | null | undefined): CountryConfig | undefined {
  if (!code) return undefined;
  return COUNTRIES.find((c) => c.code === code);
}

export function getCountryByPath(pathname: string): CountryConfig | undefined {
  return COUNTRIES.find((c) => pathname === c.path || pathname.startsWith(`${c.path}/`));
}

/** Strips a country's URL prefix from a pathname, e.g. "/ca/legal/regulatory" -> "/legal/regulatory". */
export function stripCountryPrefix(pathname: string, country: CountryConfig): string {
  if (pathname === country.path) return "/";
  if (pathname.startsWith(`${country.path}/`)) return pathname.slice(country.path.length);
  return "/";
}
